var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-badge',{staticClass:"lw-badge",attrs:{"value":_vm.content,"is-dot":_vm.isDot,"hidden":!_vm.showBadge,"type":_vm.type}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }